export default __webpack_public_path__ + "static/media/icon_kursangebote.31409eb7.svg";